module.exports = __webpack_public_path__ + "static/img/14.a2cad71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/14.jpg
// module id = nN1O
// module chunks = 16